"use client";

import React from "react";
import { ArrowRight, Award, GraduationCap, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LaTuaSicurezzaIniziaConLaFormazione() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const benefits = [{
    icon: ShieldCheck,
    text: "Conformità totale al D.Lgs 81/08"
  }, {
    icon: GraduationCap,
    text: "Docenti ingegneri esperti sul campo"
  }, {
    icon: Award,
    text: "Approccio pratico e aggiornamento continuo"
  }];
  return <section id="la-tua-sicurezza-inizia-con-la-formazione" className="relative bg-background py-20 lg:py-32 overflow-hidden border-b border-border">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.03] dark:opacity-[0.05]" style={{
      backgroundImage: 'linear-gradient(to right, var(--color-foreground) 1px, transparent 1px), linear-gradient(to bottom, var(--color-foreground) 1px, transparent 1px)',
      backgroundSize: '40px 40px'
    }}>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          
          {}
          <div ref={textRef} className={`flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1 border border-primary/30 bg-primary/5 text-primary text-sm font-semibold tracking-wider uppercase mb-6">
              <span className="w-2 h-2 bg-primary"></span>
              Formazione Sicurezza
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-foreground leading-tight mb-6 tracking-tight">
              Investi nel <br className="hidden md:block" />
              <span className="text-primary">Capitale Umano</span>
            </h1>
            
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed max-w-xl">
              La sicurezza sul lavoro inizia dalla consapevolezza. I nostri corsi di formazione trasformano l'obbligo normativo in un reale vantaggio competitivo, fornendo al tuo team le competenze necessarie per operare in totale sicurezza ed efficienza.
            </p>

            <ul className="space-y-4 mb-10 w-full max-w-md">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-foreground font-medium">
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center bg-secondary/10 border border-secondary/20 text-primary">
                    <benefit.icon className="w-4 h-4" />
                  </div>
                  <span>{benefit.text}</span>
                </li>)}
            </ul>

            <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
              <Button asChild size="lg" className="w-full sm:w-auto group">
                <Link to="#">
                  Richiedi Informazioni
                  <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="w-full sm:w-auto">
                <Link to="#i-nostri-corsi-di-formazione">
                  Esplora i Corsi
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            {}
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-primary/40 z-0"></div>
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-primary/40 z-0"></div>
            
            <div className="relative z-10 bg-card border border-border p-2 shadow-2xl">
              <div className="relative aspect-[4/3] overflow-hidden bg-muted">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1585744/img/professional_safety_training_classroom.png" alt="Sessione di formazione professionale sulla sicurezza sul lavoro" className="w-full h-full object-cover" />
                {}
                <div className="absolute inset-0 bg-gradient-to-tr from-primary/20 to-transparent mix-blend-multiply"></div>
              </div>
              
              {}
              <div className="absolute -bottom-6 -left-6 bg-background border border-border p-4 shadow-lg flex items-center gap-4">
                <div className="w-12 h-12 bg-primary flex items-center justify-center text-primary-foreground">
                  <Award className="w-6 h-6" />
                </div>
                <div>
                  <p className="text-sm font-bold text-foreground">Certificazione</p>
                  <p className="text-xs text-muted-foreground">Rilasciata a fine corso</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}